import { useParams } from "react-router-dom";
import { JOB_CARD_STATUSES_DATA, JOB_CARD_STEPS } from "./JobCardDetail.data";
import "./JobCardDetail.scss";
import React, { useEffect, useState } from "react";
import URL from "../../urls/Urls";
import ApiService from "../../services/apiService";
import { formatDate } from "../../utils/Helper";
import {
  breakPointObserver,
  ScreenSizes,
} from "../../utils/BreakpointObserver";
import Filter from "../../components/Filter/Filter";
import { FilterOptionSchema } from "../../components/Filter/filter.data";

interface VendorDetail {
  company_name: string;
  email: string;
  name: string;
  phone_number: string;
}
interface SkuData {
  prtpm_id: number;
  sku_id: number;
  sku_name: string;
  unit: string;
  quality_checks: { key: string; value: string; unit: string }[];
  quantity: number;
  pos: {
    po_number: string;
    total: number;
    delivered: number;
    left: number;
  }[];
  status: string;
  delivery_schedules: {
    expected_delivery_date: string;
    quantity: number;
    track_link: string;
    status: string;
  }[];
}

interface IClientListData {
  client_id: number;
  client_name: number;
  skus: SkuData[];
}

const JobCardDetail: React.FC = () => {
  const { id } = useParams();
  const [expandedClientIds, setExpandedClientIds] = useState<number[]>([]);
  const [activeStep, setActiveStep] = useState("RAW");
  const [clientListData, setClientListData] = useState<IClientListData[]>([]);
  const [vendorDetail, setVendorDetail] = useState<null | VendorDetail>(null);
  const [expandedSkuPrtpmIds, setExpandedSkuPrtpmIds] = useState<number[]>([]);
  const [breakpoint, setBreakpoint] = useState("");
  // const [selectedStatuses, setSelectedStatuses] = useState<{ [key: string]: FilterOptionSchema | null }>({});
  const [selectedStatuses, setSelectedStatuses] = useState<{
    [key: string]: FilterOptionSchema[];
  }>({});

  useEffect(() => {
    breakPointObserver(setBreakpoint);
  }, [breakpoint]);

  useEffect(() => {
    getJobCardDetail();
  }, []);

  const getJobCardDetail = async () => {
    try {
      const { data } = await ApiService().client.get(
        URL.JOBCARD.GET_JOBCARD_DETAIL(Number(id))
      );
      setVendorDetail(data.data.vendor_detail);
      console.log("DATAAAA", data);
      setClientListData(data.data.clients);
    } catch (error) {
      console.error("error fetching Sku Detail", error);
    }
  };

  const handleSkuExpansion = (client_id: number) => {
    setExpandedClientIds((prev) =>
      prev.includes(client_id)
        ? prev.filter((id) => id !== client_id)
        : [...prev, client_id]
    );
  };

  const handleStatusUpdate = async (updatedStatus: string, prtpmId: number) => {
    try {
      const { data } = await ApiService().client.put(
        URL.JOBCARD.UPDATE_SKU_PRODUCT_STATUS,
        {
          status: updatedStatus,
          prtpmId: prtpmId,
        }
      );
      setClientListData((prev) =>
        prev.map((client) => ({
          ...client,
          skus: client.skus.map((sku) =>
            sku.prtpm_id === prtpmId ? { ...sku, status: updatedStatus } : sku
          ),
        }))
      );
    } catch (error) {
      console.error("error updatig Sku Detail", error);
    }
  };

  const getDaysOverdue = (
    expectedDateString: string,
    status: string
  ): number => {
    if (status !== "Scheduled") {
      return 0;
    }
    const expected = new Date(expectedDateString);
    const today = new Date();

    expected.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffMs = today.getTime() - expected.getTime();
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
  };

  return (
    <div className="job-card-detail-page py-12 px-16 border-box full-width flex-column gap-16">
      <p className="bold xetgo-font-tag ">Execution Sheet</p>
      <div className="job-card-detail-page-main-container flex-column gap-12">
        <div className="vendor-detail-jobcard-main-container py-16 px-16 gap-16 flex-row align-items-center">
          <div className="flex-column gap-16 flex-1 full-width">
            <div className="flex-row xetgo-font-tag gap-10">
              <p className="flex-row align-items-center justify-content-space-between flex-1">
                <span>Vendor Name</span> <span>:</span>{" "}
              </p>
              <p className="flex-1">{vendorDetail?.company_name}</p>
            </div>
            <div className="flex-row xetgo-font-tag gap-10">
              <p className="flex-row align-items-center justify-content-space-between flex-1">
                <span>Phone</span> <span>:</span>{" "}
              </p>
              <p className="flex-1">{vendorDetail?.phone_number}</p>
            </div>
          </div>
          <div className="flex-column gap-16 flex-1 full-width">
            <div className="flex-row xetgo-font-tag gap-10">
              <p className="flex-row align-items-center justify-content-space-between flex-1">
                <span>POC </span> <span>:</span>{" "}
              </p>
              <p className="flex-1">{vendorDetail?.name}</p>
            </div>
            <div className="flex-row xetgo-font-tag gap-10">
              <p className="flex-row align-items-center justify-content-space-between flex-1">
                <span>Email</span> <span>:</span>{" "}
              </p>
              <p className="flex-1">{vendorDetail?.email}</p>
            </div>
          </div>
        </div>
        <div className="job-card-all-skus-container flex-column gap-12">
          {clientListData.length > 0 &&
            clientListData.map((client: IClientListData) => (
              <div
                key={client.client_id}
                className="job-card-sku-main-container flex-column gap-12 cursor-pointer p-12"
              >
                <div
                  onClick={() => handleSkuExpansion(client.client_id)}
                  className="flex-row align-items-center justify-content-space-between xetgo-font-tag"
                >
                  <div className="flex-column gap-12">
                    <p style={{ color: "#0061DC" }} className="bold">
                      {client.client_name}
                    </p>
                  </div>

                  <div className="flex-row align-items-end gap-48">
                    {expandedClientIds.includes(client.client_id) ? (
                      <img
                        height={21}
                        width={21}
                        className="job-card-dropdown-icon cursor-pointer"
                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240715100443-chevron-down.svg"
                        alt="down-arrow-icon"
                      />
                    ) : (
                      <img
                        height={21}
                        width={21}
                        className="cursor-pointer"
                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240221141539-chevron-down+%282%29.svg"
                        alt="up-arrow-icon"
                      />
                    )}
                  </div>
                </div>
                {expandedClientIds.includes(client.client_id) &&
                  client.skus.map((sku, skuIndex) => (
                    <div key={sku.sku_id} className="flex-column gap-14">
                      {expandedClientIds.includes(client.client_id) && (
                        <div className="unexpanded-sku-heading-box job-card-sku-details-container px-12 py-14 flex-column gap-12 xetgo-font-tag">
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedSkuPrtpmIds((prev) =>
                                prev.includes(sku.prtpm_id)
                                  ? prev.filter((id) => id !== sku.prtpm_id)
                                  : [...prev, sku.prtpm_id]
                              );
                            }}
                            className="  flex-row align-items-center justify-content-space-between xetgo-font-tag"
                          >
                            <div className="flex-row align-items-center gap-8">
                              <p style={{ color: "#333333" }} className="bold">
                                SKU {skuIndex + 1} : {sku.sku_name}
                              </p>
                              <div className="flex-row align-items-center gap-8">
                                {" "}
                                <p
                                  style={{ color: "#4A4A4A" }}
                                  className="bold"
                                >
                                  Qty : {sku.quantity}
                                </p>
                                <p
                                  style={{ color: "#4A4A4A" }}
                                  className="bold"
                                >
                                  SKU Code:{sku.sku_id}
                                </p>
                              </div>
                            </div>
                            {expandedSkuPrtpmIds.includes(sku.prtpm_id) ? (
                              <img
                                style={{ rotate: "180deg" }}
                                height={21}
                                width={21}
                                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240715100443-chevron-down.svg"
                                alt="arrow-icon"
                              />
                            ) : (
                              <img
                                height={21}
                                width={21}
                                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240715100443-chevron-down.svg"
                                alt="arrow-icon"
                              />
                            )}
                          </div>
                          {expandedSkuPrtpmIds.includes(sku.prtpm_id) && (
                            <div className="sku-extra-details flex-column gap-8">
                              <div className="qc-po-conntainer flex-column gap-12 px-16 py-12">
                                {sku.quality_checks.length > 0 && (
                                  <div className="qc-grid  flex-column gap-16 flex-1 full-width">
                                    {sku.quality_checks.map((qc, qcIndex) => (
                                      <div
                                        key={qcIndex}
                                        className="flex-row xetgo-font-tag gap-10"
                                      >
                                        <p className="flex-row align-items-center justify-content-space-between flex-1">
                                          <span>{qc.key}</span> <span>:</span>{" "}
                                        </p>
                                        <p className="flex-1">
                                          {qc.value} {qc.unit}
                                        </p>
                                      </div>
                                    ))}
                                  </div>
                                )}
                                {breakpoint !== ScreenSizes.MOBILE ? (
                                  <div className="all-po-container">
                                    <div className="po-grid po-border-bottom xetgo-font-tag bold">
                                      <p className="px-16 py-12 right-border">
                                        PO No.
                                      </p>
                                      <p className="right-border px-16 py-12">
                                        Total
                                      </p>
                                      <p className="right-border px-16 py-12">
                                        Left Qty
                                      </p>
                                      <p className=" px-16 py-12">Delivered</p>
                                    </div>
                                    {sku.pos.length > 0 &&
                                      sku.pos.map((po, poIndex) => (
                                        <div
                                          key={poIndex}
                                          className={`po-grid ${
                                            sku.pos.length - 1 !== poIndex &&
                                            "po-border-bottom"
                                          }`}
                                        >
                                          <p className=" right-border px-16 py-12">
                                            {po.po_number}
                                          </p>
                                          <p className="right-border px-16 py-12">
                                            {po.total}
                                          </p>
                                          <p className="right-border px-16 py-12">
                                            {po.left}
                                          </p>
                                          <p className="px-16 py-12">
                                            {po.delivered}
                                          </p>
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  <div className="flex-column gap-8 ">
                                    {sku.pos.length > 0 &&
                                      sku.pos.map((po, poIndex) => (
                                        <div
                                          key={poIndex}
                                          className="all-po-container flex-column gap-8 py-12 px-8"
                                        >
                                          <div className="flex-row align-items-center justify-content-space-between">
                                            <p className="xetgo-font-tag bolder">
                                              PO No.
                                            </p>
                                            <p>{po.po_number}</p>
                                          </div>
                                          <div className="flex-row align-items-center justify-content-space-between">
                                            <p className="xetgo-font-tag bolder">
                                              Left Qty
                                            </p>
                                            <p className="">{po.left}</p>
                                          </div>
                                          <div className="flex-row align-items-center justify-content-space-between">
                                            <p className="xetgo-font-tag bolder">
                                              Total
                                            </p>
                                            <p className="">{po.total}</p>
                                          </div>
                                          <div className="flex-row align-items-center justify-content-space-between">
                                            <p className="xetgo-font-tag bolder">
                                              Delivered
                                            </p>
                                            <p className="">{po.delivered}</p>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                )}
                              </div>
                              <div className="vendor-detail-jobcard-main-container flex-column ">
                                <div className="ds-padding-mob flex-row align-items-center justify-content-space-between px-16 py-12 border-box full-width">
                                  <p className="xetgo-font-tag bold">
                                    Delivery Schedule
                                  </p>

                                  <img
                                    height={16}
                                    width={16}
                                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250425121709-%2B.svg"
                                    alt="add-icon"
                                  />
                                </div>
                                <div className="jobcard-schedule-section full-width">
                                  <div className="heading-schedule schedule-date-grid xetgo-font-tag bold">
                                    <p className="ds-padding-mob px-16 py-12 right-border">
                                      Date
                                    </p>
                                    <p className="ds-padding-mob right-border px-16 py-12">
                                      Quantity
                                    </p>
                                    <p className="ds-padding-mob px-16 py-12">
                                      Status
                                    </p>
                                  </div>
                                  {sku.delivery_schedules.length > 0 && (
                                    <div className="all-schedules-container">
                                      {sku.delivery_schedules.map(
                                        (schedule, deliveryIndex) => {
                                          const daysOverdue = getDaysOverdue(
                                            schedule.expected_delivery_date,
                                            schedule.status
                                          );
                                          const uniqueKey = `${sku.prtpm_id}_${deliveryIndex}`;
                                          return (
                                            <div
                                              key={deliveryIndex}
                                              className={`schedule xetgo-font-tag schedule-date-grid  ${
                                                sku.delivery_schedules.length -
                                                  1 !==
                                                  deliveryIndex &&
                                                "ds-border-bottom"
                                              }`}
                                            >
                                              <p className="ds-padding-mob flex-row align-items-center justify-content-space-between px-16 py-12 right-border">
                                                <span>
                                                  {formatDate(
                                                    schedule.expected_delivery_date
                                                  )}
                                                </span>
                                                {daysOverdue > 0 && (
                                                  <span className="over-due-delivery py-4 px-16 flex-row align-items-center justify-content-center">
                                                    {`${daysOverdue} ${
                                                      breakpoint !==
                                                      ScreenSizes.MOBILE
                                                        ? "days"
                                                        : "d"
                                                    }`}
                                                  </span>
                                                )}
                                              </p>
                                              <p className="ds-padding-mob flex-row align-items-center right-border px-16 py-12">
                                                {schedule.quantity}
                                              </p>
                                              <div className="ds-padding-mob flex-row align-items-center px-16 py-12">
                                                {schedule.status}
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div
                                onClick={(e) => e.stopPropagation()}
                                className="remark-main-container"
                              >
                                <textarea
                                  placeholder="Add remarks here..."
                                  className="jobcard-remark full-width full-heigth px-16 py-8 border-box"
                                ></textarea>
                                <img
                                  height={18}
                                  width={18}
                                  className="send-remark-icon"
                                  src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250425115958-send.svg"
                                  alt="send-icon"
                                />
                              </div>
                              <div
                                onClick={(e) => e.stopPropagation()}
                                className="all-steps-main-container flex-row p-16"
                              >
                                {(() => {
                                  // Find the current step index, default to 0 if no match found
                                  let currentStepIndex =
                                    JOB_CARD_STEPS.findIndex(
                                      (step) => step.value === sku.status
                                    );
                                  if (currentStepIndex === -1)
                                    currentStepIndex = 0;

                                  return JOB_CARD_STEPS.map(
                                    (step, stepIndex) => {
                                      const isCurrent =
                                        stepIndex === currentStepIndex;
                                      const isCompleted =
                                        stepIndex <= currentStepIndex;
                                      const showNextArrow = isCurrent;

                                      return (
                                        <div
                                          key={stepIndex}
                                          className="step-container xetgo-font-tag flex-row align-items-center"
                                          style={{
                                            cursor: isCurrent
                                              ? "pointer"
                                              : "default",
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (!isCurrent) return;

                                            const nextStep =
                                              JOB_CARD_STEPS[stepIndex + 1];
                                            if (nextStep) {
                                              handleStatusUpdate(
                                                nextStep.value,
                                                sku.prtpm_id
                                              );
                                            }
                                          }}
                                        >
                                          <div className="flex-column tex-align-center gap-10 align-items-center">
                                            <img
                                              className="status-icon"
                                              src={
                                                isCompleted
                                                  ? step.active_icon
                                                  : step.inactive_icon
                                              }
                                              alt="status-icon"
                                            />
                                            <div className="flex-row gap-4">
                                              <p
                                                className={`bolder ${
                                                  isCompleted
                                                    ? "active-step"
                                                    : ""
                                                }`}
                                              >
                                                {step.name}
                                              </p>
                                              {showNextArrow &&
                                                stepIndex !==
                                                  JOB_CARD_STEPS.length - 1 && (
                                                  <img
                                                    height={16}
                                                    width={16}
                                                    src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250428072405-Frame+1321315793.svg"
                                                    alt="forward-icon"
                                                  />
                                                )}
                                            </div>
                                          </div>

                                          {stepIndex !==
                                            JOB_CARD_STEPS.length - 1 && (
                                            <p
                                              className={`dots-line flex-row align-items-center flex-1 ${
                                                isCompleted ? "active-step" : ""
                                              }`}
                                            >
                                              ...........
                                            </p>
                                          )}
                                        </div>
                                      );
                                    }
                                  );
                                })()}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default JobCardDetail;
